(() => {
  "use strict";

  if (window.eesPartnerCapture) return;
  const state = { status: "pending", ready: Promise.resolve() };
  window.eesPartnerCapture = state;
  let started = false;

  function incoming() {
    const query = window.location.search.replace(/^\?/, "");
    const values = [];
    for (const part of query.split("&")) {
      const split = part.indexOf("=");
      const key = split < 0 ? part : part.slice(0, split);
      // URLSearchParams is forgiving of malformed escapes; attribution must not be.
      if (new URLSearchParams(key + "=").has("am_id")) {
        values.push(decodeURIComponent((split < 0 ? "" : part.slice(split + 1)).replace(/\+/g, " ")));
      }
    }
    if (values.length) return values;
    return document.cookie.split(";")
      .map(part => part.trimStart())
      .filter(part => part.startsWith("am_id="))
      .map(part => decodeURIComponent(part.slice(6)));
  }

  function allowed() {
    try {
      return window.navigator?.globalPrivacyControl !== true &&
        window.Shopify?.customerPrivacy?.marketingAllowed() === true;
    } catch {
      return false;
    }
  }

  async function capture() {
    if (started) return;
    if (!allowed()) {
      state.status = "waiting-consent";
      return;
    }
    let values;
    try {
      values = incoming();
    } catch {
      state.status = "ambiguous";
      return;
    }
    if (!values.length) {
      state.status = "missing";
      return;
    }
    if (values.length !== 1 || !values[0] || values[0].length > 512 ||
        values[0].trim() !== values[0] || /[\u0000-\u001f\u007f]/.test(values[0])) {
      state.status = "ambiguous";
      return;
    }
    const partner = values[0];
    const root = window.Shopify?.routes?.root || "/";
    // Only same-origin cart endpoints are allowed, including localized storefronts.
    if (!/^\/(?!\/)/.test(root) || /[\u0000-\u0020\u007f\\?#]/.test(root) || !root.endsWith("/")) {
      state.status = "unconfirmed";
      return;
    }
    started = true;
    state.status = "reading-cart";
    try {
      const before = await fetch(root + "cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      });
      if (!before.ok) throw new Error("cart-read");
      const cart = await before.json();
      const existing = cart.attributes?.am_id;
      if (existing === partner) {
        state.status = "already-saved";
        return;
      }
      if (existing !== undefined && existing !== null && existing !== "") {
        // Preserve a conflicting partner already observed on this cart.
        state.status = "conflict";
        return;
      }
      if (!allowed()) {
        started = false;
        state.status = "waiting-consent";
        return;
      }
      state.status = "saving";
      const response = await fetch(root + "cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { am_id: partner } })
      });
      if (!response.ok) throw new Error("cart-write");
      const saved = await response.json();
      state.status = saved.attributes?.am_id === partner ? "saved" : "unconfirmed";
    } catch {
      // A lost response may follow a successful write. Do not submit it again.
      state.status = "unconfirmed";
    }
  }

  function run() {
    if (!started) state.ready = capture();
  }

  // This asynchronous backup cannot guarantee express checkout attribution.
  // Server-side order attribution remains primary; checkout buttons stay intact.
  document.addEventListener("visitorConsentCollected", run);
  run();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    try {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        error => { if (!error) run(); }
      );
    } catch {
      state.status = "waiting-consent";
    }
  }
})();
